<template>
  <div>
    <el-drawer
      ref="drawer"
      size="45%"
      :visible.sync="viewDrawer"
      :destroy-on-close="true"
      @close="closeDrawer"
      :wrapperClosable="false"
      :before-close="beforeClose"
    >
      <div class="el-drawer__content" v-loading="isLoading">
        <el-form ref="form" :model="formModel" :rules="rules">
          <el-row :gutter="15">
            <el-col :sm="12">
              <el-form-item label="ULD ID Code" prop="uld_id_code">
                <el-input type="text" @input="get_id_codes" v-model="formModel.uld_id_code" />
              </el-form-item>
            </el-col>
            <el-col :sm="12">
              <el-form-item label="Old ID Code" prop="old_number_code">
                <el-input type="text" v-model="formModel.old_number_code" />
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="15">
            <el-col :sm="12">
              <el-form-item label="Category" prop="category">
                <el-select v-model="formModel.category" clearable>
                  <el-option
                    v-for="item in categories"
                    :key="item.value"
                    :label="item.name"
                    :value="item.value"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :sm="12">
              <el-form-item label="Manufacturer" prop="manufacturer_id">
                <el-select
                  v-model="formModel.manufacturer_id"
                  clearable
                  filterable
                >
                  <el-option
                    v-for="item in manufacturers"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-form-item label="ULD Part No." prop="jo_part_id">
            <el-select v-model="formModel.jo_part_id" clearable filterable>
              <el-option
                v-for="item in spareParts"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-row :gutter="15">
            <el-col :span="12">
              <el-form-item label="TSO Ser No." prop="tso_ser_no">
                <el-input v-model="formModel.tso_ser_no"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="Manufacturing Date" prop="manuf_date">
                <el-date-picker
                  type="date"
                  v-model="formModel.manuf_date"
                ></el-date-picker>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="15">
            <el-col :span="12">
              <el-form-item label="Type" prop="type">
                <el-input v-model="formModel.type"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="Owner Code" prop="owner">
                <el-input v-model="formModel.owner"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-form-item label="Description" prop="description">
            <el-select v-model="formModel.description" clearable filterable>
              <el-option
                v-for="item in descriptions"
                :key="item.name"
                :label="item.name"
                :value="item.name"
              ></el-option>
            </el-select>
          </el-form-item>
          <!-- <a
            v-if="formModel.id"
            @click.prevent="viewDoc"
            href="#"
            title="View CMM"
            >View CMM</a
          >-->
          <el-collapse-transition>
            <a
              v-if="formModel.id"
              :href="formModel.cmm.directory"
              target="_blank"
              >View CMM</a
            >
          </el-collapse-transition>
        </el-form>
        <div class="el-drawer__footer" v-if="!isReadonly">
          <el-button
            v-if="!user.isRole([2, 3])"
            size="small"
            type="primary"
            @click="save"
            >Save</el-button
          >
          <el-button
            v-if="formModel.id"
            size="small"
            type="primary"
            @click="
              $router.push({
                name: 'repairMasterlistUld',
                params: { id: formModel.id }
              })
            "
            >ULD History</el-button
          >
        </div>
      </div>
    </el-drawer>
  </div>
</template>

<script>
import moment from "moment";

import Masterlist from "@/models/Masterlist";
import Manufacturer from "@/models/Manufacturer";
import Description from "@/models/RepairDescription";
import Category from "@/models/RepairCategory";
import SpareParts from "@/models/SpareParts";
import CMM from "@/models/CMM";
import ULD from "@/models/ULD";

export default {
  name: "masterlistForm",
  props: {
    readonly: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      isLoading: false,
      viewDrawer: false,
      formModel: {
        type: "",
        owner: ""
      },
      rules: {
        manufacturer_id: [
          { required: true, message: "Manufacturer is required." }
        ],
        jo_part_id: [{ required: true, message: "Spare Part is required." }],
        tso_ser_no: [{ required: true, message: "TSO Ser No. is required." }],
        manuf_date: [
          { required: true, message: "Manufacturing date is required." }
        ],
        owner: [{ required: true, message: "Owner is required." }],
        type: [{ required: true, message: "Type is required." }],
        description: [{ required: true, message: "Description is required." }],
        uld_id_code: [{ required: true, message: "Code is required." }],
        category: [{ required: true, message: "Category is required." }]
      },
      descriptions: [],
      manufacturers: [],
      spareParts: [],
      categories: []
    };
  },
  computed: {
    isReadonly() {
      return this.readonly ? true : false;
    },
    user() {
      return this.$store.getters["auth/user"];
    }
  },
  methods: {
    get_id_codes: function(event) {
      this.formModel.type = this.formModel.uld_id_code.substring(0, 3);
      this.formModel.owner = this.formModel.uld_id_code.slice(-2);
    },
    open(id) {
      if (id) {
        // fetch masterlist info
        this.isLoading = true;
        Masterlist.list({ id: id }).then(resp => {
          this.isLoading = false;
          if (resp) {
            this.formModel = { ...resp.data[0] };
            this.$nextTick(() => {
              this.$refs.form.clearValidate();
            });
          }
        });
      }
      this.viewDrawer = true;
      this.$nextTick(() => {
        this.$refs.form.clearValidate();
      });
    },
    closeDrawer() {
      this.viewDrawer = false;
      this.formModel = {};
    },
    beforeClose(done) {
      if (this.isLoading) return false;
      return done();
    },
    getLibrary() {
      SpareParts.list({ limit: 99999 }).then(list => {
        this.spareParts = list.data;
      });
      Manufacturer.list({ limit: 99999 }).then(list => {
        this.manufacturers = list.data;
      });
      Description.list({ limit: 99999 }).then(list => {
        this.descriptions = list.data;
      });
      Category.list({ limit: 99999 }).then(list => {
        this.categories = list.data;
      });
      CMM.list({ limit: 99999 }).then(list => {
        this.cmms = list.data;
      });
    },
    viewDoc() {
      window.open(
        `/pdf-viewer/doc?type=cmm&id=${this.formModel.cmm.id}`,
        "_blank"
      );
    },
    save() {
      this.$confirm("Do you want to save the Masterlist information?")
        .then(() => {
          this.$refs.form.validate(valid => {
            if (!valid) return false;
            this.isLoading = true;
            this.formModel.manuf_date = moment(
              this.formModel.manuf_date
            ).format("YYYY-MM-DD");
            if (this.formModel.id) {
              let payload = { ...this.formModel };
              delete payload._default;
              Masterlist.update(payload).then(resp => {
                this.isLoading = false;
                if (resp.code == 200) {
                  this.$notify({
                    type: "success",
                    message: "Repair Masterlist information saved.",
                    position: "bottom-right"
                  });
                  this.formModel = new Masterlist();
                  this.closeDrawer();
                  this.$emit("fetchList");
                }
              });
            } else {
              Masterlist.store(this.formModel).then(resp => {
                this.isLoading = false;
                if (resp.code == 200) {
                  this.$notify({
                    type: "success",
                    message: "Repair Masterlist information saved.",
                    position: "bottom-right"
                  });
                  this.formModel = new Masterlist();
                  this.closeDrawer();
                  this.$emit("fetchList");
                }
              });
            }
          });
        })
        .catch(() => {});
    }
  },
  mounted() {
    this.getLibrary();
  }
};
</script>

<style lang="css" scoped></style>
